import { render, staticRenderFns } from "./Bpbj.vue?vue&type=template&id=43089955&scoped=true&"
import script from "./Bpbj.vue?vue&type=script&lang=js&"
export * from "./Bpbj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43089955",
  null
  
)

export default component.exports